


























































































import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';

@Component
export default class UnlockBenefitModal extends Vue {
  @Prop({
    required: true,
    type: Boolean,
  }) showUnlockBenefitModal!: boolean;

  @Prop({
    type: Boolean,
    required: true,
  }) isUnlockedDuczSyndicateFree!: boolean;

  @Prop({
    type: Boolean,
    required: true,
  }) isUnlockedTotalLimit!: boolean;

  @Prop({
    type: Boolean,
    required: true,
  }) isUnlockedBenefitLimit!: boolean;

  @Prop({
    type: Boolean,
    required: true,
  }) isUnlockedDuczFreeMinimum!: boolean;

  @Prop({
    type: Boolean,
    required: true,
  }) isUnlockedDuczFoodMaximum!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) loadingSaveButton!: boolean

  @Prop({
    type: Number,
    required: true,
  }) duczSyndicateFreePercent!: number;

  @Prop({
    type: Number,
    required: true,
  }) benefitSumPercent!: number;

  @Prop({
    type: Number,
    required: true,
  }) totalReadjustmentPercent!: number;

  @Prop({
    type: Number,
    required: true,
  }) duczFreeMinimumValue!: number;

  @Prop({
    type: Number,
    required: true,
  }) duczFoodMaximumValue!: number;

  get formattedDuczFreeMinimumValue(): string {
    return `R$ ${this.duczFreeMinimumValue.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  get formattedDuczFoodMaximumValue(): string {
    return `R$ ${this.duczFoodMaximumValue.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  save() {
    this.$emit('save');
  }

  close() {
    this.$emit('close');
  }
}
